/**
 * Created by Fernando Torres on 13/12/2017.
 */
import BaseStore from './base-store'
import http from '@/services/http.service'
import store from '@/store/index'

const parseUrl = (state, id) => {
  if (state.relationModel && id) {
    return state.model + '/' + id + '/' + state.relationModel
  } else {
    return id ? state.model + '/' + id : state.model
  }
}

const removeInternalParams = (params) => {
  if (typeof params === 'object') {
    for (let a in params) {
      if (a.indexOf('$') >= 0) {
        delete params[a]
      }
    }
  }
  return params
}

export default class BasePivotStore extends BaseStore {
  constructor (model, relationModel) {
    super(model)
    this.state.relationModel = relationModel
    this.actions.get = ({dispatch, commit, getters, rootGetters, state}, payload) => {
      let params = removeInternalParams(Object.assign({}, payload))
      let id = params.id
      delete params.id
      let request = http.get(parseUrl(state, id), {params: params})
      request.then(response => {
        commit('items', response.data.items)
      }).catch(error => {
        store.dispatch('notifications/error', {
          title: 'Error',
          description: 'Hubo un error al tratar de obtener el elemento'
        })
        throw new Error(error.message)
      })
      return request
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/base-pivot-store.js